/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleRentalLocation
 */
export interface VehicleRentalLocation {
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalLocation
     */
    vendorCode: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalLocation
     */
    vendorName: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalLocation
     */
    vendorLocationId: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalLocation
     */
    metroCode: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalLocation
     */
    address?: string;
    /**
     * 
     * @type {number}
     * @memberof VehicleRentalLocation
     */
    latitude: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleRentalLocation
     */
    longitude: number;
}

/**
 * Check if a given object implements the VehicleRentalLocation interface.
 */
export function instanceOfVehicleRentalLocation(value: object): value is VehicleRentalLocation {
    if (!('vendorCode' in value) || value['vendorCode'] === undefined) return false;
    if (!('vendorName' in value) || value['vendorName'] === undefined) return false;
    if (!('vendorLocationId' in value) || value['vendorLocationId'] === undefined) return false;
    if (!('metroCode' in value) || value['metroCode'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    return true;
}

export function VehicleRentalLocationFromJSON(json: any): VehicleRentalLocation {
    return VehicleRentalLocationFromJSONTyped(json, false);
}

export function VehicleRentalLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleRentalLocation {
    if (json == null) {
        return json;
    }
    return {
        
        'vendorCode': json['vendor_code'],
        'vendorName': json['vendor_name'],
        'vendorLocationId': json['vendor_location_id'],
        'metroCode': json['metro_code'],
        'address': json['address'] == null ? undefined : json['address'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
    };
}

export function VehicleRentalLocationToJSON(json: any): VehicleRentalLocation {
    return VehicleRentalLocationToJSONTyped(json, false);
}

export function VehicleRentalLocationToJSONTyped(value?: VehicleRentalLocation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vendor_code': value['vendorCode'],
        'vendor_name': value['vendorName'],
        'vendor_location_id': value['vendorLocationId'],
        'metro_code': value['metroCode'],
        'address': value['address'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
    };
}

